import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import { FileObject } from 'react-mui-dropzone';
import { useEffect } from 'react';
import * as amplitude from '@amplitude/analytics-browser';
import Gallery from '../files/Gallery';
import { uploadHairLossPhotosHash } from './constants';
import { Page } from './ui';

type Props = {
  otherPhotos: FileObject[];
  handleDeletePhoto: (file: FileObject, index: number, type: string) => void;
  onDoneClick: () => void;
};

const ReviewHairLossPhotos = ({ otherPhotos, handleDeletePhoto, onDoneClick }: Props) => {
  const { t } = useTranslation('photosPage');
  const navigate = useNavigate();
  const { pathname, search } = useLocation();

  useEffect(() => {
    if (!otherPhotos.length) {
      navigate(`${pathname}${search}${uploadHairLossPhotosHash}`);
    }
    amplitude.track('photo_flow_hair_confirm');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Page>
      <Page.Title>{t('uploadMorePhotos')}</Page.Title>
      <Page.UploadBox>
        <Page.UploadBox.Image>
          <Gallery photos={otherPhotos} onDeletePhoto={(file, index) => handleDeletePhoto(file, index, 'other')} />
        </Page.UploadBox.Image>
        <Page.UploadBox.Container>
          <Page.UploadBox.Container.Title>{t('wantToAddMorePhotos')}</Page.UploadBox.Container.Title>
          <Page.UploadBox.Container.Text>{t('theMorePhotosYouProvide')}</Page.UploadBox.Container.Text>
          <Page.UploadBox.Container.Action>
            <Page.Button onClick={() => onDoneClick()}>
              <Page.Link.Secondary>{t('done')}</Page.Link.Secondary>
            </Page.Button>
            <Page.Link to={`${pathname}${search}${uploadHairLossPhotosHash}`}>
              <Page.Link.Custom
                className="tw-border tw-border-solid tw-border-black
               tw-bg-white tw-text-black tw-hover:tw-text-black"
              >
                {t('addMore')}
              </Page.Link.Custom>
            </Page.Link>
          </Page.UploadBox.Container.Action>
        </Page.UploadBox.Container>
      </Page.UploadBox>
    </Page>
  );
};

export default ReviewHairLossPhotos;
